import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import '@/styles/BackgroundChat.css';
// import backgroundImage from '@/images/1000A_56.jpg';
import backgroundImage from '@/images/1011_039.jpg';
/**
 * BackgroundChat component.
 *
 * This component displays a background image. If an image URL is provided via props, it will use that image;
 * otherwise, it will use a default image.
 *
 * @param {BackgroundProps} props - The props for the component.
 * @returns {JSX.Element} The BackgroundChat component.
 */
const BackgroundChat = ({ image }) => {
    return (_jsx("div", { className: "background-image", style: { backgroundImage: `url(${image || backgroundImage})` }, "data-testid": "background-image" }));
};
export default BackgroundChat;
